import { Component, EventEmitter, OnInit, Input } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { Document_Upload_File } from 'src/app/models/common';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { CommonService } from 'src/app/services/common.service';
import { IstDataShareService } from 'src/app/services/ist/ist-datashare.service';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { UserService } from 'src/app/services/user.service';
import * as $ from 'jquery';
import { serviceConstants } from 'src/app/constants/service.constants';
import * as _ from 'lodash';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ist-activities-seminars-speakers',
  templateUrl: './ist-activities-seminars-speakers.component.html',
  styleUrls: ['./ist-activities-seminars-speakers.component.scss']
})
export class IstActivitiesSeminarsSpeakersComponent implements OnInit {

  @Input() public Content: any;
  ActivitySessions: UntypedFormGroup;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  formData: FormData;
  files: any[];
  SeminosList: any = [];
  ApplicationID: any;
  Allfiles = [];
  userType: string = "";
  FilesList = [];
  ScreenFilesList = [];
  uploadInput: EventEmitter<any>;
  humanizeBytes: Function;
  document_attach_list: Document_Upload_File[] = [];
  loadGrid = false;
  filesCopy: any;
  staticformFields: any;
  constructor(
    private summaryService: IstSummaryService,
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    private appFunctions: AppFunctionsService,
    private datashareService: IstDataShareService,
    private userService: UserService,
    public commonService: CommonService
  ) {
    this.files = [];
    this.Allfiles = [];
    this.uploadInput = new EventEmitter<any>();
  }

  ngOnInit(): void {
    this.userType = this.userService.getUserType();
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });

    this.getStaticFiledsData('SCR-010');
    this.FilesList = _.cloneDeep(this.Content.content.docList);
    this.files = [];

    this.filesCopy = _.cloneDeep(this.FilesList);
    this.ActivitySessions = new UntypedFormGroup({
      ID: new UntypedFormControl(""),
      TITLE: new UntypedFormControl(""),
      FIST_NAME: new UntypedFormControl(""),
      LAST_NAME: new UntypedFormControl(""),
      QUALIFICATION: new UntypedFormControl(""),
      OCCUPATION: new UntypedFormControl(""),
      FileNameExt: new UntypedFormControl(""),
      FileId: new UntypedFormControl(""),
      FILES: new UntypedFormControl(null),
    });

    this.ActivitySessions.patchValue(this.Content.content.rowData);

    if (this.Content.heading == 'View') {
      this.ActivitySessions.disable();
    }
  }

  uploadchange(event): void {
    if (this.document_attach_list == undefined || this.document_attach_list == null) {
      this.document_attach_list = [];
    }
    let hasUnFormat = false;
    let hasMultipleFiles = false;
    let Duplicate_File_List = [];

    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      var file = event.target.files[i].name;
      var ext = file.match(/\.([^\.]+)$/)[1];
      var filesize = event.target.files[i].size;

      if (file != null && ((filesize > 15728640) || (ext != 'docx' && ext != 'doc' && ext != 'ppt' && ext != 'pptx' && ext != 'xls' && ext != 'xlsx' && ext != 'txt' && ext != 'pdf'))) {
        hasUnFormat = true;
      }
      else {
        let hasValue;
        let value;
        uploadFile.ID = this.commonService.getUniqueId();
        uploadFile.DOCUMENT_NAME = event.target.files[i].name;
        uploadFile.File = event.target.files[i];
        uploadFile.Status = "Add";
        if (this.FilesList?.length > 0) {
          hasValue = this.FilesList?.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase());
        }

        if (this.document_attach_list?.length > 0) {
          value = this.document_attach_list.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase());

        }

        if (hasValue?.length > 0 || value?.length > 0) {
          hasMultipleFiles = true;
          Duplicate_File_List.push(uploadFile.DOCUMENT_NAME);
        }

        else if (this.staticformFields.Activities_CF.IS_MULTISELECT) {
          this.document_attach_list.push(uploadFile);
        }
        else if (this.FilesList == undefined) {
          this.document_attach_list = [];
          this.FilesList = [];
          this.document_attach_list.push(uploadFile);

        }
        else {
          this.document_attach_list = [];
          this.FilesList.forEach((item) => {
            item.Status = "Delete";
          })
          this.document_attach_list.push(uploadFile);
        }



      }
    }

    if (hasUnFormat) {
      this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 15MB");
    }

    if (hasMultipleFiles) {
      this.commonService.ValidationBanner("File already exists with " + Duplicate_File_List.join(', ') + ". Please update the unique file name");
    }
  }
  DeleteUpload(file): void {
    if (file.Status == "Add") {
      let code = file.ID;
      // this.documaent_attach_list = this.documaent_attach_list.filter(function (sec) {
      //   return sec.ID != code;
      // }, code);
      let index = this.document_attach_list.findIndex(x => x.ID == file.ID);
      this.document_attach_list.splice(index, 1);
    }
    else {
      file.Status = "Delete";
      let index = this.document_attach_list.findIndex(x => x.ID == file.ID);
      this.document_attach_list.splice(index, 1);
    }
  }

  DownloadFile(ID) {
    var fileID = ID;
    let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
    window.open(Url);
  }

  ViewFile(fileID, fileName) {
    this.commonService.previewFile(fileID, fileName, "med");
  }

  save() {
    if (this.SessionvalidateControls()) {
      var formData = this.ActivitySessions.value;

      formData.TITLE = formData.TITLE == null ? null : formData.TITLE == undefined ? undefined : formData.TITLE.trim();
      formData.FIST_NAME = formData.FIST_NAME == null ? null : formData.FIST_NAME == undefined ? undefined : formData.FIST_NAME.trim();
      formData.LAST_NAME = formData.LAST_NAME == null ? null : formData.LAST_NAME == undefined ? undefined : formData.LAST_NAME.trim();
      formData.QUALIFICATION = formData.QUALIFICATION == null ? null : formData.QUALIFICATION == undefined ? undefined : formData.QUALIFICATION.trim();
      formData.OCCUPATION = formData.OCCUPATION == null ? null : formData.OCCUPATION == undefined ? undefined : formData.OCCUPATION.trim();

      //if (!this.staticformFields.Activities_CF.IS_MULTISELECT) {
      //  this.FilesList?.forEach((item) => {
      //    item.Status = "Delete";
      //    this.document_attach_list.push(item);
      //  });
      //}
        this.FilesList?.forEach((item) => {
          this.document_attach_list.push(item);
        });
      formData['FILES'] = this.document_attach_list;
      let SpkName = formData['FIST_NAME'] + " " + (formData['LAST_NAME'] == null ? '' : formData['LAST_NAME']);
      if (this.Content.heading == 'Add') {
        formData['ID'] = this.commonService.getUniqueId();
        // this.commonService.SuccessBanner("Speaker " + SpkName + " details added successfully");
        //this.action.next(formData);
        //this.ActivitySessions.reset();
        //this.document_attach_list = [];
        this.modalRef.close(formData);
      } else {

        if (this.Content.content.rowData['TITLE'] == this.ActivitySessions.controls['TITLE'].value
          && this.Content.content.rowData['FIST_NAME'] == this.ActivitySessions.controls['FIST_NAME'].value
          && this.Content.content.rowData['LAST_NAME'] == this.ActivitySessions.controls['LAST_NAME'].value
          && this.Content.content.rowData['QUALIFICATION'] == this.ActivitySessions.controls['QUALIFICATION'].value
          && this.Content.content.rowData['OCCUPATION'] == this.ActivitySessions.controls['OCCUPATION'].value
          //&& _.isEqual(this.Content.content.rowData['FILES'], this.filesCopy) && formData['FILES'].length == 0
          && _.isEqual(this.Content.content.rowData['FILES'], formData['FILES']) && formData['FILES'].length == 0
        ) {
          this.modalRef.dismiss();
          //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'No changes have been performed' } } });
        } else {
          //this.commonService.SuccessBanner("Speaker " + SpkName + " details updated successfully");
          //   this.action.next(formData);
          this.modalRef.close(formData);
        }
      }

    }
  }


  SessionvalidateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.ActivitySessions.value;

    if (this.staticformFields?.AS_TITLE.IS_MANDATORY && this.staticformFields?.AS_TITLE.IS_Display) {
      if (formData.TITLE === null || formData.TITLE === "" || formData.TITLE === undefined) {
        $("#TITLE").addClass("ng-touched ng-invalid validate-error");
        $("#TITLE").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.AS_TITLE.LABEL_NAME} <br/>`;
      } else if (formData.TITLE != null && formData.TITLE != undefined && formData.TITLE.trim() == "") {
        $("#TITLE").addClass("ng-touched ng-invalid validate-error");
        $("#TITLE").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.AS_TITLE.LABEL_NAME} <br/>`;
      }
      else {
        $("#TITLE").addClass("ng-untouched ng-valid");
        $("#TITLE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.FIST_NAME.IS_MANDATORY && this.staticformFields?.FIST_NAME.IS_Display) {
      if (formData.FIST_NAME === null || formData.FIST_NAME === "" || formData.FIST_NAME === undefined) {
        $("#FIST_NAME").addClass("ng-touched ng-invalid validate-error");
        $("#FIST_NAME").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.FIST_NAME.LABEL_NAME} <br/>`;
        isValid = false;
      } else if (formData.FIST_NAME != null && formData.FIST_NAME != undefined && formData.FIST_NAME.trim() == "") {
        $("#FIST_NAME").addClass("ng-touched ng-invalid validate-error");
        $("#FIST_NAME").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.FIST_NAME.LABEL_NAME} <br/>`;
        isValid = false;
      }
      else {
        $("#FIST_NAME").addClass("ng-untouched ng-valid");
        $("#FIST_NAME").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.LAST_NAME.IS_MANDATORY && this.staticformFields?.LAST_NAME.IS_Display) {
      if (formData.LAST_NAME === null || formData.LAST_NAME === "") {
        $("#LAST_NAME").addClass("ng-touched ng-invalid validate-error");
        $("#LAST_NAME").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.LAST_NAME.LABEL_NAME} <br/>`;
        isValid = false;
      } else if (formData.LAST_NAME != null && formData.LAST_NAME != undefined && formData.LAST_NAME.trim() == "") {
        $("#LAST_NAME").addClass("ng-touched ng-invalid validate-error");
        $("#LAST_NAME").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.LAST_NAME.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#LAST_NAME").addClass("ng-untouched ng-valid");
        $("#LAST_NAME").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.OCCUPATION.IS_MANDATORY && this.staticformFields?.OCCUPATION.IS_Display) {
      if (formData.OCCUPATION === null || formData.OCCUPATION === "" || formData.OCCUPATION === undefined) {
        $("#OCCUPATION").addClass("ng-touched ng-invalid validate-error");
        $("#OCCUPATION").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.OCCUPATION.LABEL_NAME} <br/>`;
        isValid = false;
      } else if (formData.OCCUPATION != null && formData.OCCUPATION != undefined && formData.OCCUPATION.trim() == "") {
        $("#OCCUPATION").addClass("ng-touched ng-invalid validate-error");
        $("#OCCUPATION").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.OCCUPATION.LABEL_NAME} <br/>`;
        isValid = false;
      }
      else {
        $("#OCCUPATION").addClass("ng-untouched ng-valid");
        $("#OCCUPATION").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.QUALIFICATION.IS_MANDATORY && this.staticformFields?.QUALIFICATION.IS_Display) {
      if (formData.QUALIFICATION === null || formData.QUALIFICATION === "" || formData.QUALIFICATION === undefined) {
        $("#QUALIFICATION").addClass("ng-touched ng-invalid validate-error");
        $("#QUALIFICATION").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.QUALIFICATION.LABEL_NAME} <br/>`;
        isValid = false;
      } else if (formData.QUALIFICATION != null && formData.QUALIFICATION != undefined && formData.QUALIFICATION.trim() == "") {
        $("#QUALIFICATION").addClass("ng-touched ng-invalid validate-error");
        $("#QUALIFICATION").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.QUALIFICATION.LABEL_NAME} <br/>`;
        isValid = false;
      }
      else {
        $("#QUALIFICATION").addClass("ng-untouched ng-valid");
        $("#QUALIFICATION").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.Activities_CF.IS_MANDATORY && this.staticformFields?.Activities_CF.IS_Display) {
      if (this.FilesList != undefined && this.FilesList.length > 0) {
        this.FilesList.forEach((item) => {
          this.document_attach_list.push(item);
        });
      }
      if (this.document_attach_list == null || this.document_attach_list.length == 0) {
        isValid = false;
        message += `Please upload ${this.staticformFields?.Activities_CF.LABEL_NAME} <br/>`;
      }
    }

    if (!isValid)
      this.commonService.ValidationBanner(message);
    // this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: message } } });
    return isValid;
  }

  getRecordFprEdit() {
    this.summaryService.getScreenDataForEdit("api/ISTActivitiesseminars/Edit?RecordID=" + this.Content.content.id).subscribe(result => {
      //this.rowData = result["FilesList"];
      var count = 0;
      result["ChildList"].forEach(x => {
        count = count + 1;
        if (count == parseInt("1")) {
          this.GetSessionDetails(x);
        }
      });

    });
  }

  GetSessionDetails(data) {

    this.files = [];

    // this.FilesList = this.rowData.filter((xyz) => {
    //   return (xyz.FileID == data["ID"])
    // });
    ;
    this.ActivitySessions.controls["ID"].setValue(data["ID"]);
    if (data["FileNameExt"] != null && data["FileNameExt"] != undefined && data["FileNameExt"] != "") {
      this.ActivitySessions.controls["FileNameExt"].setValue(data["FileNameExt"]);
    }
    else {
      this.ActivitySessions.controls["FileNameExt"].setValue("");
    }
    this.ActivitySessions.controls["TITLE"].setValue(data["TITLE"]);
    this.ActivitySessions.controls["FIST_NAME"].setValue(data["FIST_NAME"]);
    this.ActivitySessions.controls["LAST_NAME"].setValue(data["LAST_NAME"]);
    this.ActivitySessions.controls["QUALIFICATION"].setValue(data["QUALIFICATION"]);
    this.ActivitySessions.controls["OCCUPATION"].setValue(data["OCCUPATION"]);
    this.ActivitySessions.controls["FILES"].setValue(data["FILES"]);
    this.files = data["FileNameExt"];
  }

  DeleteSavedUpload(item): void {
    this.commonService.CheckIsFileIsRefereancedInReviw(item).subscribe((x) => {
      if (x["Status"] == 2 && x["Data"] == false) {
        this.commonService.ValidationBanner(x["Message"]);
      }
      else {
        let index = this.FilesList.findIndex(x => x.ID == item);
        if (index != -1) {
          //this.FilesList.splice(index, 1);
          this.FilesList[index].Status = "Delete";
        }
        this.ActivitySessions.markAsDirty();
      }
    })


  }
  close() {
    this.canExit().then((x) => {
      this.modalRef.dismiss();
    });
  }
  canExit() {
    if (this.ActivitySessions.dirty && this.Content.heading != 'Add') {
      return this.commonService.CanDeactivateBanner();
    }
    else {
      return Promise.resolve(true);
    }
  }

  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode, this.ApplicationID)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
      });
  }
}
